export enum FroalaEvent {
    Blur = 'blur',
    ButtonsRefresh = 'buttons.refresh',
    CharCounterExceeded = 'charCounter.exceeded',
    CharCounterUpdate = 'charCounter.update',
    Click = 'click',
    CodeViewUpdate = 'codeView.update',
    CommandsAfter = 'commands.after',
    CommandsBefore = 'commands.before',
    CommandsMousedown = 'commands.mousedown',
    CommandsRedo = 'commands.redo',
    CommandsUndo = 'commands.undo',
    ContentChanged = 'contentChanged',
    Destroy = 'destroy',
    Drop = 'drop',
    EditOff = 'edit.off',
    EditOn = 'edit.on',
    ElementDropped = 'element.dropped',
    EmbedlyBeforeRemove = 'embedly.beforeRemove',
    FileBeforeUpload = 'file.beforeUpload',
    FileError = 'file.error',
    FileInserted = 'file.inserted',
    FileUnlink = 'file.unlink',
    FileUploaded = 'file.uploaded',
    FileUploadedToS3 = 'file.uploadedToS3',
    FilesManagerBeforeUpload = 'filesManager.beforeUpload',
    FilesManagerError = 'filesManager.error',
    FilesManagerUploaded = 'filesManager.uploaded',
    FilesManagerUploadedToS3 = 'filesManager.uploadedToS3',
    Focus = 'focus',
    HtmlAfterGet = 'html.afterGet',
    HtmlBeforeGet = 'html.beforeGet',
    HtmlGet = 'html.get',
    HtmlProcessGet = 'html.processGet',
    HtmlSet = 'html.set',
    ImageBeforePasteUpload = 'image.beforePasteUpload',
    ImageBeforeRemove = 'image.beforeRemove',
    ImageBeforeUpload = 'image.beforeUpload',
    ImageError = 'image.error',
    ImageHideResizer = 'image.hideResizer',
    ImageInserted = 'image.inserted',
    ImageLoaded = 'image.loaded',
    ImageRemoved = 'image.removed',
    ImageReplaced = 'image.replaced',
    ImageResize = 'image.resize',
    ImageResizeEnd = 'image.resizeEnd',
    ImageUploaded = 'image.uploaded',
    ImageUploadedToS3 = 'image.uploadedToS3',
    ImageManagerBeforeDeleteImage = 'imageManager.beforeDeleteImage',
    ImageManagerError = 'imageManager.error',
    ImageManagerImageDeleted = 'imageManager.imageDeleted',
    ImageManagerImageLoaded = 'imageManager.imageLoaded',
    ImageManagerImagesLoaded = 'imageManager.imagesLoaded',
    InitializationDelayed = 'initializationDelayed',
    Initialized = 'initialized',
    Input = 'input',
    Keydown = 'keydown',
    Keypress = 'keypress',
    Keyup = 'keyup',
    LinkBad = 'link.bad',
    LinkBeforeInsert = 'link.beforeInsert',
    LinkBeforeRemove = 'link.beforeRemove',
    Mousedown = 'mousedown',
    Mouseup = 'mouseup',
    PasteAfter = 'paste.after',
    PasteAfterCleanup = 'paste.afterCleanup',
    PasteBefore = 'paste.before',
    PasteBeforeCleanup = 'paste.beforeCleanup',
    PasteWordPaste = 'paste.wordPaste',
    PopupsHideId = 'popups.hide.[id]',
    PopupsShowId = 'popups.show.[id]',
    PositionRefresh = 'position.refresh',
    QuickInsertCommandsAfter = 'quickInsert.commands.after',
    QuickInsertCommandsBefore = 'quickInsert.commands.before',
    SaveAfter = 'save.after',
    SaveBefore = 'save.before',
    SaveError = 'save.error',
    Shortcut = 'shortcut',
    SnapshotAfter = 'snapshot.after',
    SnapshotBefore = 'snapshot.before',
    TableInserted = 'table.inserted',
    TableResized = 'table.resized',
    ToolbarEsc = 'toolbar.esc',
    ToolbarFocusEditor = 'toolbar.focusEditor',
    ToolbarHide = 'toolbar.hide',
    ToolbarShow = 'toolbar.show',
    Touchend = 'touchend',
    Touchstart = 'touchstart',
    UrlLinked = 'url.linked',
    VideoBeforeRemove = 'video.beforeRemove',
    VideoBeforeUpload = 'video.beforeUpload',
    VideoCodeError = 'video.codeError',
    VideoHideResizer = 'video.hideResizer',
    VideoInserted = 'video.inserted',
    VideoLinkError = 'video.linkError',
    VideoLoaded = 'video.loaded',
    VideoRemoved = 'video.removed',
    VideoReplaced = 'video.replaced',
    VideoUploaded = 'video.uploaded',
    VideoUploadedToS3 = 'video.uploadedToS3',
    WindowCopy = 'window.copy',
    WindowCut = 'window.cut',
}
